<mip-modal maxWidth="500px" [size]="isDesktop ? 'md' : 'full'">
  <!-- MODAL -->
  <mip-card class="invite">
    <mip-card-header class="--flex-row" [class.--flex-row--space-between]="slideIndex === 1" (click)="slideIndex = 0">
      <!-- HEADER: back -->
      <button mat-button *ngIf="slideIndex === 1" (click)="slidePrev()">
        <mip-icon icon="chevron-left"></mip-icon>
      </button>

      <!-- HEADER: close -->
      <a mat-button class="__close" routerLink="../">
        <mip-icon icon="times"></mip-icon>
      </a>
    </mip-card-header>

    <!-- MODAL: CONTENT -->
    <mip-card-content class="__card-content --no-padding --flex-column --flex-row--space-between">
      <span class="__bg-img" [style.background-image]="'url(' + assetsPath + '/images/invite-1.png)'"></span>

      <div class="__container">
        <swiper #swiper [config]="config" (slideChange)="onSlideChange()">
          <ng-template class="__item" swiperSlide>
            <h1 class="__title mip-color--text-primary" mipTranslate="profile.invite.title">Referral Bonus!</h1>
            <h3 class="__description" mipTranslate="profile.invite.description">Invite your friends to join GotChosen and earn 5% referral bonus from their ad monetization.</h3>

            <button class="__button-next --flex-row" (click)="slideNext()">
              <span mipTranslate="profile.invite.see-details">See details</span>
              <mip-icon icon="chevron-right-small"></mip-icon>
            </button>

            <div class="__invite-btn">
              <h3 class="__description" mipTranslate="profile.invite.invite-link">Your friend must register via your invite link below:</h3>

              <button mat-stroked-button class="__profile-actions-item mip-color--bg-light mip-color--bd-primary mip-color--text-primary" (click)="shareInvite()">
                <span mipTranslate="profile.invite.invite-action">Invite Link</span>
              </button>
            </div>
          </ng-template>

          <ng-template class="__item" swiperSlide>
            <h1 class="__title mip-color--text-primary" mipTranslate="profile.invite.more-details.title">Referral Bonus Details</h1>

            <h3 class="__description" mipTranslate="profile.invite.more-details.description">
              The 5% referral bonus is paid monthly from the total ad revenue generated from your referred influencer.
            </h3>

            <h3 class="__description" mipTranslate="profile.invite.more-details.must-registered">You must be registered on GotChosen ADS program in order to receive the bonus.</h3>
          </ng-template>
        </swiper>
      </div>
    </mip-card-content>
  </mip-card>
</mip-modal>
